import { cn } from '../../lib/utils';

export function StepCard({ children, className, ...props }) {
  return (
    <div className={cn('flex flex-col flex-1 min-h-0 w-full bg-[var(--q3-surface-default)]', className)} {...props}>
      <div className="space-y-6">{children}</div>
    </div>
  );
}
